import { render } from "./IconLogout.vue?vue&type=template&id=81826f0e"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconLogout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "81826f0e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('81826f0e', __exports__)) {
    api.reload('81826f0e', __exports__)
  }
  
  module.hot.accept("./IconLogout.vue?vue&type=template&id=81826f0e", () => {
    api.rerender('81826f0e', render)
  })

}


export default __exports__